// utils.js
export const formatToIndianRupee = (amount) => {
    // Return a default string if amount is NaN
    if (isNaN(amount)) return "₹ 0"; 
    const number = Number(amount);
    return number.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};